const isMock = false,
  apiVersion = "v0",
  urlProtocol =
    !process.env.REACT_APP_ENV || process.env.REACT_APP_ENV?.trim() === "com"
      ? "https"
      : "http",
  urlType = process.env.REACT_APP_ENV?.trim() || "com",
  isLocalhost = process.env.REACT_APP_ENV?.trim() === "localhost",
  mockUrl = `http://0.0.0.0:5000/${apiVersion}`;

export const config = {
  urlType: urlType,
  urlProtocol: urlProtocol,
  authenticateUrl: isLocalhost
    ? `http://localhost:34300`
    : `${urlProtocol}://account.3gaam.${urlType}`,
  hallUrl: `${urlProtocol}://3gaam.${urlType}/bio`,
  apiUrl: {
    account: isLocalhost
      ? `http://localhost:34301/${apiVersion}`
      : isMock
      ? mockUrl
      : `${urlProtocol}://account-api.3gaam.${urlType}/${apiVersion}`,
    communication: isLocalhost
      ? `http://localhost:34301/${apiVersion}`
      : isMock
      ? mockUrl
      : `${urlProtocol}://communication-api.3gaam.${urlType}/${apiVersion}`,
    consultancy: isLocalhost
      ? `http://localhost:34304/${apiVersion}`
      : isMock
      ? mockUrl
      : `${urlProtocol}://consultancy-api.3gaam.${urlType}/${apiVersion}`,
    store: isLocalhost
      ? `http://localhost:34304/${apiVersion}`
      : isMock
      ? mockUrl
      : `${urlProtocol}://store-api.3gaam.${urlType}/${apiVersion}`,
  },
  intervalChatRequestTime: 7000,
  asciiMessage: `
    _______  _______  _______  _______  __   __ 
    |       ||       ||   _   ||   _   ||  |_|  |
    |___    ||    ___||  |_|  ||  |_|  ||       |
    ___|   ||   | __ |       ||       ||       |
    |___    ||   ||  ||       ||       ||       |
    ___|   ||   |_| ||   _   ||   _   || ||_|| |
    |_______||_______||__| |__||__| |__||_|   |_|

  `,
};

export const firebaseConfig = {
  apiKey: "AIzaSyADK8lXzsGlEvhEhxGUWCYLwxxyxintn6g",
  authDomain: "atitech-3gaam.firebaseapp.com",
  projectId: "atitech-3gaam",
  storageBucket: "atitech-3gaam.appspot.com",
  messagingSenderId: "658670262230",
  appId: "1:658670262230:web:d4d7f7cdbd004027e1f677",
};

export const VAPID =
  "BIUmQg5m1OhTgTobmBeE1qJuaEwqmlwBY_QrC7gMH2sndOMnCHdh2eUUYL0WdzZw1y3fsxeRL03Z-2t5aCfI080";
